export const ANDROID = 'android';
export const IOS = 'ios';
export const HUAWEI = 'huawei';
export const WEB = 'web';
export const PX = 'px';
export const CHECKOUT = 'checkout';
export const WALLET = 'wallet';
export const PAYMENT_ORIGINS = ['px', 'wallet', 'checkout'];
export const URL_IMAGE_HEADER =
  'https://pedidosya-api.dhmedia.io/image/pedidosya/deals-navigations/generic-images/PromosBancarias-Header.jpg';
export const DH_IMAGES =
  'https://pedidosya-api.dhmedia.io/image/pedidosya/products/';
export const URL_VENDOR =
  'https://pedidosya-api.dhmedia.io/image/pedidosya/restaurants/';
export const URL_EMPTY_PROMOTIONS =
  'https://pedidosya-api.dhmedia.io/image/pedidosya/deals-navigations/generic-images/Partners.png';
export const URL_IMAGE_DF_REVAMP =
  'https://pedidosya.dhmedia.io/image/pedidosya/only-home-squad/display-block/DF_Almuerzos-cenas-Revamp.png';
export const URL_IMAGE_DF =
  'https://pedidosya.dhmedia.io/image/pedidosya/only-home-squad/display-block/almuerzo-cena.png';

// Revamp fenix
export const OFF = 'OFF';
export const DCTO = 'DCTO';
export const DSCTO = 'DSCTO';
export const DTO = 'DTO';
export const REINTEGRO = 'Reintegro';
export const DESCUENTO = 'Descuento';
export const REEMBOLSO = 'Reembolso';
export const CASHBACK = 'Cashback';

export const COUNTRY_DISCOUNT_TAGS = {
  1: OFF,
  2: DCTO,
  3: OFF,
  7: DSCTO,
  8: OFF,
  13: DSCTO,
  15: OFF,
};

export const COUNTRY_CASHBACK_TAGS = {
  1: REINTEGRO,
  2: REEMBOLSO,
  3: REINTEGRO,
  11: CASHBACK,
};

export const STATE = {
  ENABLED: 'enabled',
  HOVER: 'hover',
  FOCUSED: 'focused',
  PRESSED: 'pressed',
  LOADING: 'loading',
  DISABLED: 'disabled',
  SELECTED: 'selected',
  IDLE: 'idle',
  ACTIVE: 'active',
  ERROR: 'error',
};

export const vendorItemVariants = {
  headerOn: 'header-on',
  headerOff: 'header-off',
};

export const occasionTypes = {
  delivery: 'delivery',
  pickup: 'pickup',
};

export const deliveryETAVariants = {
  default: 'default',
  quick: 'quick',
  delay: 'delay',
};

export const deliveryFeeVariants = {
  default: 'default',
  free: 'free',
  variable: 'variable',
  'plus-free': 'plus-free',
  'plus-discount': 'plus-discount',
};

export const ENTER_KEY_VALUE = 'Enter';

export const METADATA = {
  title: 'Promociones, descuentos y ofertas en Delivery - PedidosYa',
  description:
    'Pedí las mejores ofertas en restaurantes y supermercados. ¡Ahorrá en tus comidas preferidas, pizzas, helados y más!',
  image:
    'https://pedidosya-api.dhmedia.io/image/pedidosya/deals-navigations/metadata/promotions-metadata.png',
  type: 'website',
  fb_app_id: '342906170186',
  site_name: 'PedidosYa',
  favicon: 'https://live.pystatic.com/webassets/pwa/pedidosya.ico',
};

// HOME
export const STATE_COMPONENT = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  ERROR: 'ERROR',
};

export const CATEGORY_LABEL = {
  VOUCHER: 'VOUCHER',
  RESTAURANT: 'RESTAURANT',
  PAYMENT_METHODS: 'PAYMENT_METHODS',
  GROCERIES: 'GROCERIES',
  PLUS: 'PLUS',
};

export const COMPONENT_TYPE = {
  BANNER_DELIVERY_FREE: 'BANNER_DELIVERY_FREE',
  BANNER_PLUS: 'BANNER_PLUS',
  VOUCHER: 'VOUCHER',
  VOUCHER_PROSPECT: 'VOUCHER_PROSPECT',
  SWIMLANE_ITEM_PLUS: 'SWIMLANE_ITEM_PLUS',
  SWIMLANE_ITEM_FOOD: 'SWIMLANE_ITEM_FOOD',
  SWIMLANE_VENDOR_FOOD: 'SWIMLANE_VENDOR_FOOD',
  BANNER_FOOD: 'BANNER_FOOD',
  RECOMMENDED_PAYMENT_METHOD_CARD: 'RECOMMENDED_PAYMENT_METHOD_CARD',
  SWIMLANE_ITEM_GROCERIES: 'SWIMLANE_ITEM_GROCERIES',
  SWIMLANE_VENDOR_GROCERIES: 'SWIMLANE_VENDOR_GROCERIES',
  BANNER_GROCERIES: 'BANNER_GROCERIES',
  BANNER_JOKER: 'BANNER_JOKER',
  INCENTIVE_MESSAGE: 'INCENTIVE_MESSAGE',
};

export const CATEGORY_TYPE = {
  WITHOUT_CATEGORY: 'WITHOUT_CATEGORY',
  RESTAURANT: 'RESTAURANT',
  PAYMENT_METHODS: 'PAYMENT_METHODS',
  GROCERIES: 'GROCERIES',
  PLUS: 'PLUS',
};

// Tabs constants
export const TABS = {
  HOME: 'home',
  RESTAURANTS: 'restaurants',
  QC: 'qc',
  PROMOTIONS: 'promotions',
  EMPTY_STATE: 'empty-state',
};
